<template>
  <div>
    <Headersys />
    <div class="content">
      <div>
        <canvas id="qrCode"></canvas>
        <div class="qr-tips">手机扫描二维码进行申报</div>
      </div>
    </div>
    <Back />
  </div>
</template>
<script>
import QRCode from "qrcode";
export default {
  name: '',
  data() {
    return {
      //
      masterId: "",
      masterDeptId: '',
    };
  },
  created() {
    //
    var options = this.$route.query
    this.masterId = options.masterId
    this.masterDeptId = options.masterDeptId
  },
  mounted() {
    //
    this.generateQrcode()
  },
  methods: {
    //
    generateQrcode() {
      var canvas = document.getElementById("qrCode");
      // 调用函数去生成二维码，参数依次为：二维码的容器、要生成的内容、回调函数   http://192.168.1.104:8080
      QRCode.toCanvas(
        canvas,
        `http://192.168.1.104:8080/#/sxsbForm?masterId=${this.masterId}&masterDeptId=${this.masterDeptId}`,
        function (error) {
          if (error) {
            console.error(error);
          }
        }
      );
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

#qrCode {
  width: 80rem !important;
  height: 80rem !important;
  display: block;
  margin: 0 auto 5rem;
}

.qr-tips {
  text-align: center;
  font-size: 5rem;
}
</style>